import { useContext } from 'react';
import { awayJersey, homeJersey } from '@/common/assets';
import { useNewTranslations } from '@/common/translations';
import type { TeamInfoData } from '../types';
import { PrematchDataContext } from '../store';
import mapTeamInfoApiDataToTeamInfoData from '../utils/mapTeamInfoApiDataToTeamInfoData';

export default function usePrematchData() {
  const translate = useNewTranslations();
  const context = useContext(PrematchDataContext);

  if (!context) {
    throw new Error('usePrematchData must be used within a PrematchDataProvider');
  }

  const { teamInfo, ...rest } = context;

  const defaultTeamInfo: TeamInfoData = {
    home: {
      name: translate('PreMatchStats.Home'),
      jersey: homeJersey,
      isNationalTeam: false,
    },
    away: {
      name: translate('PreMatchStats.Away'),
      jersey: awayJersey,
      isNationalTeam: false,
    },
    lineupAvailable: false,
  };

  const teams = teamInfo === null ? defaultTeamInfo : mapTeamInfoApiDataToTeamInfoData(teamInfo);

  return {
    teams,
    ...rest,
  };
}
